/**
 * GetPackagePricesAndAvailabilitiesV2 PPS Endpoint
 *
 * Fetches available extras/auxiliary services for a given hotel package.
 */
import { ppsClient } from './ppsClient';
import { PPS_ENDPOINTS } from './config';
import {
  GetExtrasResponseSchema,
  type GetExtrasRequest,
  type GetExtrasResponse,
} from '@/types/schemas/pps';

export async function getExtras(request: GetExtrasRequest): Promise<GetExtrasResponse> {
  return ppsClient.post<GetExtrasRequest, GetExtrasResponse>({
    endpoint: PPS_ENDPOINTS.GET_EXTRAS,
    data: request,
    responseSchema: GetExtrasResponseSchema,
  });
}
